import React, { useState, useEffect } from 'react';
import T from 'prop-types';

import snippets from './pub-sub-code-snippets';
import ContentSection from '../code-explorer-react/content-section';
import parseData from '../code-explorer-react/parse-data';
import randomWordArray from '../code-explorer-react/random-word-array';
import checkApiKey from '../code-explorer-react/check-api-key';

function parseResponse(res = null) {
  if (!res || !res.text) {
    throw new Error('Failed to receive response Object');
  }
  return res.text();
}

function handleError(e) {
  console.log('Errors occured retrieving API key', e);
  return null;
}

async function initialize(demoURL, collection) {
  const apiDemoKeyValue = await fetch(demoURL)
    .then(parseResponse)
    .then(checkApiKey)
    .catch(handleError);

  const API_KEY = apiDemoKeyValue || '[API_KEY]';
  const CHANNEL_NAME = randomWordArray(2).join('-');
  const CLIENT_ID = randomWordArray(2).join('-');
  const MAPBOX_ACCESS_TOKEN = '[MAPBOX_ACCESS_TOKEN]';

  // Update the code samples with a Demo key and channel anme
  const tokens = { API_KEY, CHANNEL_NAME, CLIENT_ID, MAPBOX_ACCESS_TOKEN };
  return [collection].map(row => parseData(row, tokens));
}

export default function Component({ apiKeyURL }) {
  const [collection, setCollection] = useState(null);
  const [indexes, setIndexes] = useState([0, 0]);

  const [pubTabIndex, subTabIndex] = indexes;
  const { publish, subscribe } = collection || {};

  const updateIndexValue = index => value => {
    indexes[index] = value;
    const next = [...indexes];
    setIndexes(next);
  };

  useEffect(
    () =>
      (async () => {
        const [dataset] = await initialize(apiKeyURL, snippets);
        setCollection(dataset.data);
      })(),
    [],
  );

  if (!collection) return null;

  return (
    <div className="ui-code-explorer-shadow bg-white m-0 block p-16">
      <div className="overflow-hidden relative">
        <ContentSection title="publish" setState={updateIndexValue(0)} languages={publish} index={pubTabIndex} />
        <div className="h-8 block"></div>
        <ContentSection title="subscribe" setState={updateIndexValue(1)} languages={subscribe} index={subTabIndex} />
      </div>
    </div>
  );
}

Component.propTypes = {
  apiKeyURL: T.string,
};
